import React from "react"
import Countdown from 'react-countdown';
import { getNewYearDayDate } from '../utils/helpers';

const NewYearCountdownDays = () => {
    const countdownDate = getNewYearDayDate();

    const countdownRenderer = ({ days }) => (
        <>
            {days} {days === 1 ? 'day' : 'days'}
        </>
    );

    return <Countdown date={countdownDate} renderer={countdownRenderer} />;
};

export default NewYearCountdownDays;
